import React from "react";
import CogRoundelLoader from "components/svg/CogRoundelLoader";
import styles from "./loading.module.css";
import './loader.css';

export const SmallLoading = (props) => {
  return (
    <div className={styles.SmallWrapper} {...props}>
      <CogRoundelLoader gradToUse={props.gradToUse || undefined} />
    </div>
  );
};

export const Loading = (props) => {
  return (
    <div className={styles.DefaultWrapper}>
      <CogRoundelLoader gradToUse={props.gradToUse || undefined} />
    </div>
  );
};

export default Loading;
